// extracted by mini-css-extract-plugin
export var cardTitle = "_jg-1";
export var commentBubble = "_jg-e";
export var commentForm = "_jg-a";
export var commentInput = "_jg-b";
export var commentLabel = "_jg-d";
export var commentPrompt = "_jg-9";
export var csatCard = "_jg-0";
export var feedbackSection = "_jg-7";
export var starDisabled = "_jg-6";
export var starEmpty = "_jg-5";
export var starFilled = "_jg-4";
export var starWrapper = "_jg-3";
export var starsContainer = "_jg-2";
export var submittedComment = "_jg-c";
export var thankYouText = "_jg-8";